// extracted by mini-css-extract-plugin
export default {"detailed-view__gross-amount":"detailed-view_detailed-view__gross-amount__7kvbW","detailed-view__gross-amount__label":"detailed-view_detailed-view__gross-amount__label__CFGt3"};